import '@tamagui/core/reset.css';
import './i18n';
import { ToastProvider, ToastViewport } from '@tamagui/toast';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { TamaguiProvider, YStack, styled } from 'tamagui';
import config from 'tamagui-config';

import { mainBackground } from './assets';
import { CurrentToast } from './components/common';
import { AmplifyProvider } from './contexts/AmplifyContext';
import { AppSyncProvider } from './contexts/AppSyncContext';
import { DraggingProvider } from './contexts/DraggingContext';
import { FirmwareProvider, useFirmwareContext } from './contexts/FirmwareContext';
import { Router } from './routes/Router';

const MainContainer = styled(YStack, {
  width: 1920,
  height: 480,
  backgroundColor: '$gray1',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  variants: {
    locked: {
      true: {
        backgroundImage: `url(${mainBackground})`,
      },
      false: {
        backgroundImage: 'none',
      },
    },
  },
});

const DarkOverlay = styled(YStack, {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  zIndex: 0,
});

export const Root = () => (
  <TamaguiProvider config={config} defaultTheme="dark">
    <ToastProvider>
      <FirmwareProvider>
        <BrowserRouter>
          <AmplifyProvider>
            <AppSyncProvider>
              <CurrentToast />
              <LockContent />
            </AppSyncProvider>
          </AmplifyProvider>
        </BrowserRouter>
      </FirmwareProvider>
      <ToastViewport position="absolute" left={744} top={331} width="auto" zIndex={9999} />
    </ToastProvider>
  </TamaguiProvider>
);

const LockContent = () => {
  const { hubName, isLocked } = useFirmwareContext();

  useEffect(() => {
    document.title = hubName;
  }, [hubName]);

  return (
    <MainContainer locked={isLocked}>
      {/* Dark overlay when locked */}
      {isLocked && <DarkOverlay />}
      <DraggingProvider onDragEnd={() => {}}>
        <Router />
      </DraggingProvider>
    </MainContainer>
  );
};
